"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryScreeningRequest = void 0;
var PrimaryScreeningRequest = /** @class */ (function () {
    function PrimaryScreeningRequest() {
        this.idNo = '';
        this.custName = '';
    }
    return PrimaryScreeningRequest;
}());
exports.PrimaryScreeningRequest = PrimaryScreeningRequest;
;
//# sourceMappingURL=primaryScreening.request.js.map